import { Dialog, Grid, styled, Typography } from "@mui/material";

export const Field = styled(Grid)({
  width: "100%",
  display: "flex",
  alignItems: "center",
  gap: "10px",
});

export const Label = styled(Typography)(({ theme }) => ({
  width: "155px",
  color: theme.palette.secondary.main,
}));

export const Container = styled(Grid)({
  display: "flex",
  gap: "10px",
});

export const Block = styled(Grid)({
  display: "flex",
  flexDirection: "column",
  gap: "10px",
  width: "48%",
});

export const DocumentViewerContainer = styled(Dialog)({
  overflow: "hidden",
  "& .MuiPaper-root": {
    maxWidth: "fit-content",
  },
});
